import React from 'react';
import { Container, Typography, Grid, Box } from '@mui/material';
import { motion, useScroll, useTransform } from 'framer-motion';
import '../About.css';

const HeroSection = () => {
  const { scrollYProgress } = useScroll();
  const y = useTransform(scrollYProgress, [0, 1], [0, 100]);

  return (
    <Box className="about-hero-section">
      <Container maxWidth="lg">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={8}>
            <Box className="hero-content">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
              >
                <Typography variant="overline" className="hero-overline">
                  Transforming Businesses Through Digital Excellence
                </Typography>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <Typography variant="h1" className="hero-title">
                  <span className="about-gradient-text">INNOVATE.</span> TRANSFORM. <br />EXCEL.
                </Typography>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
              >
                <Typography variant="body1" className="hero-description">
                  Virves Software Solutions is a global leader in digital transformation, empowering enterprises with cutting-edge solutions that drive innovation and growth. Our team of elite developers and strategists crafts bespoke digital experiences that set new industry standards.
                </Typography>
              </motion.div>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <motion.div
              className="hero-pattern"
              style={{ y }}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8, delay: 0.3 }}
            >
              <div className="pattern-circle"></div>
              <motion.div
                className="pattern-circle-2"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: 0.5 }}
              ></motion.div>
              <motion.div
                className="pattern-circle-3"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: 0.7 }}
              ></motion.div>
              <div className="pattern-dots"></div>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
      <div className="hero-background-gradient"></div>
    </Box>
  );
};

export default HeroSection; 